import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, Select } from '@ngxs/store';
import { Subject, Observable } from 'rxjs';
import { ResetSearchResults, Search, SetSearching } from '../../state/explore.actions';
import { ExploreState } from '../../state/explore.state';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { GalleryState } from 'src/app/gallery/state/gallery.state';
import { GalleryViewMode } from 'src/app/gallery/models/gallery-view-mode.enum';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { UserProfileModel } from 'src/app/auth/models/user-profile.model';
import { DialogActions } from 'src/app/dialogs/state/dialog.actions';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit, OnDestroy {
  galleryViewMode = GalleryViewMode;
  bookmarkActions = BookmarkActionsEnum;

  private ngUnsubscribe = new Subject();

  @Select(ExploreState.getSearchResults)
  searchResults$: Observable<BookmarkModel[]>;

  @Select(ExploreState.getLoading)
  loading$: Observable<boolean>;

  @Select(ExploreState.getSearchQuery)
  query$: Observable<string>;

  @Select(GalleryState.getViewMode)
  viewMode$: Observable<GalleryViewMode>;
  
  @Select(AuthState.isPremiumUser)
  isPremiumUser$: Observable<UserProfileModel>;
  
  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private location: Location,
    private router: Router
  ) {
  }

  ngOnInit() {
    // search via route param
    this.route.params
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(({ query }) => {
        this.store.dispatch(new SetSearching(true));
        this.store.dispatch(new ResetSearchResults());        
        this.store.dispatch(new Search(query));
      });
  }

  ngOnDestroy() {
    this.store.dispatch(new ResetSearchResults());
    this.store.dispatch(new SetSearching(false));

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleSelectBookmark(bookmark: BookmarkModel) {
    if (!bookmark.premium || this.store.selectSnapshot(AuthState.isPremiumUser)) {
      this.router.navigate(['/view'], { queryParams: { id: bookmark.id, type: StoryType.Module }});
    } else {
      this.store.dispatch(new DialogActions.OpenPremiumContent());
    }
  }

  goBack() {
    this.location.back();
  }

}
